import React, { FC } from "react";
import { Spin, Typography } from "antd";
import { Logo } from "../header/logo";
import styles from "./page-loading.css";

const { container, footer, error: errorClassName, title } = styles as any;

export type LoginContentProps = {
  loading: boolean;
  error?: Error;
};

export const PageLoading: FC<LoginContentProps> = ({ loading, error, children }) => {
  return (
    <div className={container}>
      <Logo />
      <Typography.Title className={title}>
        <span>Legal Pricing </span>
        <span>Made Simple</span>
      </Typography.Title>
      <div className={footer}>
        {loading ? <Spin size="large" tip="Loading..." /> : children}
        {error && (
          <Typography.Paragraph type="danger" className={errorClassName}>
            {error.message || " "}
          </Typography.Paragraph>
        )}
      </div>
    </div>
  );
};
